(function($) {
    $('.dashboard-selector').bind('change', function() {
        var $this = $(this);

        var urlTemplate = $this.data('url-template'),
            active = $this.data('active-dashboard');
        //'@Url.Action("Index", new {Id = "$dashboardId"})';
        //var active = "@Model.ActiveDashboardId.ToString()";
        var selected = $this.val();
        if (active != selected) {
            // var params = $.param({
            // selectedDivisionId: MDB.isGuid(MDB.Charts.divisionId) ? MDB.Charts.divisionId : undefined,
            // startDate: MDB.Charts.dateStart,
            // endDate: MDB.Charts.dateEnd
            // });
            
            var targetDashboardUrl = urlTemplate.replace('$dashboardId', selected).replace(encodeURIComponent('$dashboardId'), selected);
            // targetDashboardUrl +=  '?' + params;
            
            document.location = MDB.Charts.appendActiveFiltersToUrl(targetDashboardUrl);
        }
    });
})(jQuery);